import { render, staticRenderFns } from "./TheHomeAddEducationSpace.vue?vue&type=template&id=06af3524&"
import script from "./TheHomeAddEducationSpace.vue?vue&type=script&lang=js&"
export * from "./TheHomeAddEducationSpace.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports